<template>
  <!-- 退改签规则 -->
  <div>
    <div>
      <!-- 中转 -->
      <van-popup
        v-model="isShowRule"
        class="popup-width"
        closeable
        :close-on-popstate="true"
        style="max-height: 80vh;overflow-y:scroll;"
        :get-container="element"
        @close="closE"
        v-if="Transi && Transi!='false'"
      >
        <div class="tkRefundChangeRule" v-for="(item,index) in collection" :key="index">
          <div class="title">
            <span>{{ $t('C115', '成人') }}</span>
            <span> 第{{ processingnum(index) }}程 </span>
            <span>{{ item.voyage }}</span>
          </div>
          <div class="box">
            <span class="font14 ">退票费</span>
            <div class="mui-col-sm-10 mui-col-xs-10 bg-white">
              <div class="mui-col-sm-10 mui-col-xs-10 bg-white">
                <div
                  class="font12" v-for="(info, index) in item.refund" :key="index">
                  <span :class="getDateClassexe(info.dateEnd, info.dateStart)">
                    <span v-show="info.dateStart!==''&&info.dateStart!=99999">
                      <span v-show="info.dateStart&&info.dateStart!=99999">{{ info.dateStart }}</span>
                      <span v-show="info.startFlag==1">(含)</span>
                    </span>
                    <span v-show="info.dateStart!==''&&info.dateStart!=99999&&info.dateEnd!==''&&info.dateEnd!=-99999">{{ $t('H041','至') }}</span>
                    <span v-if="info.dateEnd!=-99999">
                      <span v-show="info.dateEnd">{{ info.dateEnd }}</span>
                      <span v-show="info.endFlag==1">(含)</span>
                    </span>
                    <span v-show="info.dateStart==99999">前</span>
                    <span v-show="info.dateEnd==-99999">后</span>
                    <span v-show="info.log">{{ info.log }}</span>
                    <span v-if="info.price && isPrice">
                      <span class="right">
                        &nbsp; ¥<span class="orange">{{ info.price }}</span>/人
                      </span>
                    </span>
                    <span v-else>
                      <span class="right orange">&nbsp;&nbsp;{{ info.value }}%</span>
                    </span>
                    <span
                      class="right"
                      v-show="info.value===0||info.price===0"
                    >免费</span>
                  </span>
                </div>
                <div v-html="baggageAllowance.refundRule" />
              </div>
            </div>
          </div>
          <div class="box van-hairline--top">
            <span class="font14">同舱位改签费</span>
            <div class="mui-col-sm-10 mui-col-xs-10 bg-white">
              <div
                class="font12"
                v-for="(info, index1) in item.change"
                :key="index1"
              >
                <span :class="getDateClass(info.dateEnd, info.dateStart)">
                  <span v-show="info.dateStart!==''&&info.dateStart!=99999">
                    <span v-show="info.dateStart&&info.dateStart!=99999">{{ info.dateStart }}</span>
                    <span v-show="info.startFlag==1">(含)</span>
                  </span>
                  <span v-show="info.dateStart!==''&&info.dateStart!=99999&&info.dateEnd!==''&&info.dateEnd!=-99999">{{ $t('H041','至') }}</span>
                  <span v-show="info.dateEnd!==''">
                    <span v-show="info.dateEnd&&info.dateEnd!=-99999">{{ info.dateEnd }}</span>
                    <span v-show="info.endFlag==1">(含)</span>
                  </span>
                  <span v-show="info.dateStart==99999">前</span>
                  <span v-show="info.dateEnd==-99999">后</span>
                  <span v-show="info.log">{{ info.log }}</span>

                  <span v-if="info.price && isPrice">
                    <span class="right" >&nbsp;¥<span class="orange">{{ info.price }}</span>/人</span>
                  </span>
                  <span v-else>
                    <span class="right orange" v-show="info.value"
                    >&nbsp;&nbsp;{{ info.value }}%</span>
                  </span>
                  <span class="right" v-show="info.value===0||info.price===0">免费</span>
                </span>
              </div>
              <div v-html="baggageAllowance.changeRule" />
            </div>
          </div>
          
          <div class=" font16 van-hairline--top  ">
            行李规定
          </div>
          <div class="box">
            <span class="font12">行李额</span> <span class="fr">{{ item.baggageWeight }}</span>
            <div class="font12 indent">
              {{ item.xlgd }}
            </div>
          </div>
          <div v-if="item.policyDesc">
            <div class="title font16 van-hairline--top">
              政策说明
            </div>
            <div class="box">
              <div class="font12 indent">
                {{ item.policyDesc }}
              </div>
            </div>
          </div>
          <div class="lines" v-if="collection.length!=index+1">
            -------------------------------------------------------------------
          </div>
        </div>
      </van-popup>
      <!-- 单程、往返弹窗，代码（公亮写） -->
      <van-popup
        v-model="isShowRule"
        closeable
        class="popup-width"
        :close-on-popstate="true"
        style="max-height: 80vh;overflow-y:scroll;"
        :get-container="element"
        v-else
      >
        <div class="tkRefundChangeRule">
          <div class="titlenew back_di" style="padding: 6px 0;">
            <span v-if="info && info.departCityName && info.arriveCityName ">{{ info.departCityName }} - {{ info.arriveCityName }}</span>  
          </div>
          <div class="box">
            <span class="font16_w6 ">退票费</span>
            <div class="mui-col-sm-10 mui-col-xs-10 bg-white">
              <div
                class="font12"
                v-for="(info, index) in refund"
                :key="index"
              >
                <span
                  v-if="info.dateStart == '99999'"
                  :class="getDateClass(info.dateEnd, info.dateStart)"
                >
                  {{ info.dateEnd }}
                  <span v-show="info.endFlag == 1">(含)</span>
                  前
                  <span v-show="isPrice">
                    <span
                      class="right"
                      v-show="info.value"
                    >¥<span class="orange">{{ info.price }}</span>/人</span>
                  </span>
                  <span v-show="isPrice == false">
                    <span
                      class="right"
                      v-show="info.value"
                    >{{ info.value }}%</span>
                  </span>
                  <span
                    class="right"
                    v-show="info.value === 0 || info.price === 0"
                  >免费</span>
                </span>
                <span
                  v-else-if="info.dateEnd == '-99999'"
                  :class="getDateClass(info.dateEnd, info.dateStart)"
                >
                  {{ info.dateStart }}
                  <span v-show="info.startFlag == 1">(含)</span>
                  后
                  <span v-show="isPrice">
                    <span
                      class="right"
                      v-show="info.value"
                    >¥<span class="orange">{{ info.price }}</span>/人</span>
                  </span>
                  <span v-show="isPrice == false">
                    <span
                      class="right"
                      v-show="info.value"
                    >{{ info.value }}%</span>
                  </span>
                  <span
                    class="right"
                    v-show="info.value === 0 || info.price === 0"
                  >免费</span>
                </span>
                <span
                  v-else
                  :class="getDateClass(info.dateEnd, info.dateStart)"
                >
                  {{ info.dateStart }}
                  <span v-show="info.startFlag == 1">(含)</span>
                  {{ $t('H041', '至') }}
                  {{ info.dateEnd }}
                  <span v-show="info.endFlag == 1">(含)</span>
                  <span v-show="isPrice">
                    <span
                      class="right"
                      v-show="info.value"
                    >¥<span class="orange">{{ info.price }}</span>/人</span>
                  </span>
                  <span v-show="isPrice == false">
                    <span
                      class="right"
                      v-show="info.value"
                    >{{ info.value }}%</span>
                  </span>
                  <span
                    class="right"
                    v-show="info.value === 0 || info.price === 0"
                  >免费</span>
                </span>

                <span v-show="info.log">{{ info.log }}</span>
              </div>
              <div v-html="baggageAllowance.refundRule" />
            </div>
          </div>
          <div class="box van-hairline--top">
            <span class="font16_w6">改签费</span>
            <div class="mui-col-sm-10 mui-col-xs-10 bg-white">
              <div
                class="font12 "
                v-for="(info, index1) in change"
                :key="index1"
              >
                <span
                  v-if="info.dateStart == '99999'"
                  :class="getDateClass(info.dateEnd, info.dateStart)"
                >
                  {{ info.dateEnd }}
                  <span v-show="info.endFlag == 1">(含)</span>
                  前
                  <span v-show="isPrice">
                    <span
                      class="right"
                      v-show="info.value"
                    >¥<span class="orange">{{ info.price }}</span>/人</span>
                  </span>
                  <span v-show="isPrice == false">
                    <span
                      class="right"
                      v-show="info.value"
                    >{{ info.value }}%</span>
                  </span>
                  <span
                    class="right"
                    v-show="info.value === 0 || info.price === 0"
                  >免费</span>
                </span>
                <span
                  v-else-if="info.dateEnd == '-99999'"
                  :class="getDateClass(info.dateEnd, info.dateStart)"
                >
                  {{ info.dateStart }}
                  <span v-show="info.startFlag == 1">(含)</span>
                  后
                  <span v-show="isPrice">
                    <span
                      class="right"
                      v-show="info.value"
                    >¥<span class="orange">{{ info.price }}</span>/人</span>
                  </span>
                  <span v-show="isPrice == false">
                    <span
                      class="right"
                      v-show="info.value"
                    >{{ info.value }}%</span>
                  </span>
                  <span
                    class="right"
                    v-show="info.value === 0 || info.price === 0"
                  >免费</span>
                </span>
                <span
                  v-else
                  :class="getDateClass(info.dateEnd, info.dateStart)"
                >
                  {{ info.dateStart }}
                  <span v-show="info.startFlag == 1">(含)</span>
                  {{ $t('H041', '至') }}
                  {{ info.dateEnd }}
                  <span v-show="info.endFlag == 1">(含)</span>
                  <span v-show="isPrice">
                    <span
                      class="right"
                      v-show="info.value"
                    >¥<span class="orange">{{ info.price }}</span>/人</span>
                  </span>
                  <span v-show="isPrice == false">
                    <span
                      class="right"
                      v-show="info.value"
                    >{{ info.value }}%</span>
                  </span>
                  <span
                    class="right"
                    v-show="info.value === 0 || info.price === 0"
                  >免费</span>
                </span>

                <span v-show="info.log">{{ info.log }}</span>
              </div>
              <div v-html="baggageAllowance.changeRule" />
            </div>
          </div>
          <div v-if="baggageAllowance.noshowRule && cplx=='10902'" class="box">
            <div >noShow规则</div>
            <div >{{ baggageAllowance.noshowRule }}</div>
          </div>

          
          <div class="box">
            <!--            <span class="font12">行李额</span> <span class="fr">{{ baggageAllowance.baggageWeight }}</span>-->
            <div class=" font16_w6 van-hairline--top ">
              <i class="iconfont icon-hanglixiang" style="color: #e86e30;font-size: 18px;"/> 行李规定
            </div>
            <div class="font12 ">
              <span class="indent">{{ baggageAllowance.xlgd }}</span>    
            </div>
          </div>
          <div v-if="baggageAllowance.policyDesc">
            <div class="title font16 van-hairline--top">
              政策说明
            </div>
            <div class="box">
              <div class="font12 indent">
                {{ baggageAllowance.policyDesc }}
              </div>
            </div>
          </div >
          <div v-if="cplx=='10902'" >
            <div class="title" style="font-size: 16px;">
              特殊说明
            </div>
            <div style="color:red; text-indent: 0.5rem;">
              国际中转程只能全退或者从后段往前退。单段退会影响全程使用，请谨慎提交。涉及费用核算需要时间，按照航司为准，核算后会短信通知，谢谢配合。
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>

import {Popup} from 'vant'
import { mapGetters } from "vuex"
import 'Assets/font/download3/iconfont.css'

export default {
  name: 'RefundChangeRule',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    [Popup.name]: Popup,
  },
  props: {
    obj: {
      type: Object,
      default: function () {
        return {
          // salePrice:
          // cabin:
          // departDate:
          // airline:
          //蜗牛->
          // 'cacheId':
          // 'flightNo':
          // 'cabin':
          // 'priceId
          //国际->
          // 'flightReqId': '',//航班查询请求id不能为空 ,
          // 'flightSn': '',//航班序号
          // 'cabin': '',
          // 'priceId': ''
        }
      }
    },
    cplx: {
      type: String,
      default: '10901'
    },
    element: {
      type: String,
      default: 'body'
    }
  },
  data() {
    return {
      down: {use: false},
      isShowRule: false,//显示退改规则
      refund: [],//单程直飞,
      refund1: [],//单程直飞,
      refund2: [],//单程直飞,
      change1: [],
      change2: [],
      Transit: [],
      change: [],
      isPrice: false,
      baggageAllowance: {},//行李额
      activeStep: 0,
      title_list: [
        {title: '免费行李规定'},
        {title: '退改签说明'},
      ],
      currentTime: new Date(),
      max: '',
      Transi: '',//判断是否跳转
      collection:[],//中转数据
      info:"",
    }
  },
  created() {
    this.Transi = this.$route.query.Transit
  },
  computed: {
    ...mapGetters({
      tkSearchInfo: "tk/tkSearchInfo",
    }),
  },
  methods: {
    // 单程、往返（万）
    getDateClass(date) {
      const today = new Date()
      const currentDate = new Date(date)

      if (currentDate < today) {
        return 'red'
      } else {
        return 'blue'
      }
    },
    //中转另一种处理方法
    getDateClassexe(date,start) {
      let currentDate
      date.includes('99999') ?  currentDate = new Date(start) : currentDate = new Date(date)
      let departDate=this.tkSearchInfo.queryStr.departDate //起飞日期
      let currentDatelast=currentDate.toLocaleDateString().replaceAll('/','-') //起飞前最后日期
      const today = new Date()
      if (currentDate < today) {
        if(date==-99999){
          if(departDate == currentDatelast || departDate < currentDatelast){
            return 'blue'
          }
        }
        return 'red'
      } else {
        return 'blue'
      }
    },
    //处理数字方法
    processingnum(num){
      let big=['一','二','三','四','五','六','七','八','九','十']
      return big[num]
    },
    closE() {
      this.change1 = []
      this.change2 = []
      this.refund1 = []
      this.refund2 = []
    },
    getInfo() {
      if (this.isDetail()) {
        return
      }
      var url = 'tkQuery/queryFlightRuleNew'
      if (this.cplx == '10901') {//蜗牛
        url = 'tkQuery/queryFlightRule'
      } else if (this.cplx == '10902') {
        url = 'tkIntQuery/queryFlightRule'
        if (!this.obj.flightReqId) {
          this.obj.changeRule = '以航司官网为准'
          this.obj.refundRule = '以航司官网为准'
          this.isDetail()
          return
        }
      } else if (!this.obj.airline || !this.obj.cabin || !this.obj.departDate) {
        return
      }
      this.$api[url](this.obj).then(res => {
        console.log('res',res,'this.Transi',this.Transi,'urlobj',url)
        let cache = res.data || {}
        this.refund = []
        this.change = []
        if (this.Transi && this.Transi!='false') {//代表中
          this.collection=[]
          if(cache.trasferFlightRuleBeans &&cache.trasferFlightRuleBeans.length > 0){
            cache.trasferFlightRuleBeans.forEach((oneitem,index)=>{
              let journey={
                refund:[],//退
                change:[],//改
              }
              journey.baggageWeight=oneitem.baggageWeight
              journey.voyage=oneitem.voyage
              journey.xlgd=oneitem.xlgd
              //政策说明没见过，看之前代码有就写上
              oneitem.policyDesc ? journey.policyDesc=oneitem.policyDesc : ''
              oneitem.list.forEach((twoitem)=>{
                twoitem.rangeFlag==1 ? journey.refund.push(twoitem) : journey.change.push(twoitem)
              })
              this.collection.push(journey)
            })

          }
        } else {
          if (cache.list && cache.list.length < 1) {
            var obj = {
              log: '以航司官网为准',
              dateEnd: '',
              dateStart: ''
            }
            this.refund.push(obj)
            this.change.push(obj)
          } else if (cache.list && cache.list.length > 0) {
            var s = []
            for (var i = 0; i < cache.list.length; i++) {
              s.push(cache.list[i].dateEnd)
            }
            const filteredArr = s.filter(value => value !== '-99999')
            const timestamps = filteredArr.map(item => new Date(item).getTime())
            const maxTimestamp = Math.max(...timestamps)
            const maxDate = new Date(maxTimestamp).toLocaleString()
            var dateString = maxDate
            var date = new Date(dateString)
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()
            var hour = date.getHours()
            var minute = date.getMinutes()
            // 格式化月份和日期，保证为两位数
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day
            // 格式化小时和分钟，保证为两位数
            hour = hour < 10 ? '0' + hour : hour
            minute = minute < 10 ? '0' + minute : minute
            var formattedDate = year + '-' + month + '-' + day + ' ' + hour + ':' + minute
            this.max = formattedDate
            cache.list.forEach(el => {
              if (el.rangeFlag == 1) {//退
                this.refund.push(el)
              } else if (el.rangeFlag == 2) {//改
                this.change.push(el)
              }
            })
          }
        }

        this.baggageAllowance = {
          baggageWeight: cache.baggageWeight || '',
          xlgd: cache.xlgd || '',
          changeRule: cache.changeRule,
          refundRule: cache.refundRule,
          policyDesc: cache.policyDesc,
          tgText: cache.tgText,
          noshowRule:cache.noshowRule
        }
      })
    },
    isDetail() {
      if (this.obj.refundRule || this.obj.changeRule) {
        let changeRule = this.obj.changeRule
        let refundRule = this.obj.refundRule
        let xlgd = this.obj.xlgd
        changeRule = changeRule.replace(/;/gi, '<br>')
        refundRule = refundRule.replace(/;/gi, '<br>')
        this.baggageAllowance = {
          changeRule: changeRule,
          refundRule: refundRule,
          xlgd: xlgd,
          noshowRule:this.obj.noshowRule

        }
        return true
      }
      return false
    },
    getParams() {
      this.$api['common/getParameter']({
        'paramNo': '10908'
      }).then(res => {
        var cache = res.data || {}
        if (cache.value1 == 1) {
          this.isPrice = true
        } else {
          this.isPrice = false
        }
        this.getInfo(this.obj)
      })
    },
    toggle(info) {
      this.info=info
      this.isShowRule = !this.isShowRule
      if (this.isShowRule) {
        this.getParams()
      }
    },
    jump(index) {
      var items = document.querySelectorAll('.scroll-item')
      for (var i = 0; i < items.length; i++) {
        if (index === i) {
          items[i].scrollIntoView({
            block: 'start',//默认跳转到顶部
            behavior: 'smooth'//滚动的速度
          })
        }
      }
    },
    onScroll(e) {
      let scrollItems = document.querySelectorAll('.scroll-item')
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge =
          e.target.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop
        if (judge) {
          this.activeStep = i
          break
        }
      }
    },
  }
}

</script>

<style lang="less" scoped>
@font-face {
  font-family: iconfont-h5;
  src: url(../../assets/font/PriceIcon/iconfont.eot) format("embedded-opentype"),
  url(../../assets/font/PriceIcon/iconfont.woff) format("woff"),
  url(../../assets/font/PriceIcon/iconfont.ttf) format("truetype"),
}

.wrapper {
  height: 55vh;
  overflow: hidden;
}

.tkRefundChangeRule {
  background-color: @color-background-white;
  padding: 0.3rem;
  text-align: left;

  .title {
    font-size: @font-size-18;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }

  .box {
    padding: 0.3rem 0;

    > span {
      font-weight: 500;
    }
  }

  .indent {
    text-indent: 0.5rem;
    padding-top: 0.1rem;
  }

  .pad1 {
    padding: 0.2rem 0;
  }
}

.list {
  width: 100%;
  height: 40px;
  margin-bottom: 5px;
}

.list_1 {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  white-space: nowrap;
  text-align: center;
  height: 1.83467rem;
  line-height: 1.83467rem;
  font-size: 0.64rem;
  font-weight: 500;
  margin: 0 .21333rem;
  -webkit-box-shadow: 0 0.128rem 0.34133rem 0 rgba(51, 51, 51, .06);
  box-shadow: 0 3.12px 3.5px 0 rgba(51, 51, 51, .06);
}

ul {
  width: 100%;
  height: 40px;
  line-height: 40px;
  list-style: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 3.12px 3.5px 0 rgba(51, 51, 51, .06);
}

li {
  float: left;
  white-space: nowrap;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  font-weight: 500;
  width: 100px;
}

li > span {
  cursor: pointer;
}

.result {
  width: 100%;
  height: 500px;
  overflow: scroll;
}

.result_1 {
  position: relative;
  margin: auto;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  padding: 5px 20px 5px 20px;
  border-radius: 5px;
  visibility: visible;

}

.scroll-item {
  width: 100%;
  //height: 500px;
  //height: 750px;
  margin-top: 20px;
  background: rgb(255, 255, 255);

  p {
    padding: 28px 0 15px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}

.scroll-item > span {
  font-size: 40px;
}

.scroll-item:first-child {
  margin-top: 0;
}

.scroll-item:last-child {
  height: 500px;
}

.active {
  white-space: nowrap;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  font-weight: 700;
  color: #0086f6;

  &::after {
    display: block;
    content: "";
    width: 36px;
    height: 6px;
    margin: auto;
    margin-top: -5px;
    border-bottom: 2px solid #0086f6;
    width: 100px;
  }
}

.tab_1 {
  display: flex;
  align-items: center;
  align-content: space-between;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin: 19px 0px 10px 0px;
}

.num {
  margin: 0px 0 25px 0;

  ul {
    padding: 20px 20px 20px 20px;

    li:before {
      content: "";
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      vertical-align: middle;
      margin-right: 8px;
      margin-top: -4px;
    }

    li {
      margin: 10px 0 10px 0px;
    }
  }
}

.num_p {
  padding: 5px 0 0 35px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
  color: #666;
}

.dian {
  color: #eb6100;
  display: list-item;
  margin: 10px 0 0 0;
}

.font_12 {
  margin: 15px 0px 0px 15px;
}


.red {
  color: #bbb;
  text-decoration: line-through;
}

.blue {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333;
  line-height: 12px;
}

.box_border {
  width: 100%;
  height: 320px;
  border: 1px solid #ddd;
}

.box_bottom {
  height: 30px;
  text-align: left;
  line-height: 30px;
  border-bottom: 1px solid #ddd;
  padding: 0px 0px 0px 20px;
  background: #f8f8f8;
}

.box_icon1 {
  height: 113px;
  display: flex;
  justify-content: space-between;

  .box_icon1_1 {
    width: 50%;
  }

  .box_icon1_2 {
    width: 100%;
  }
}

.box_icon2 {
  height: 113px;
  height: 113px;
  display: flex;
  justify-content: space-between;

  .box_icon1_1 {
    width: 50%;
  }

  .box_icon1_2 {
    width: 100%;
  }
}

.hello {
  width: 147px;
  height: 135px;
  padding: 11px 1px 0px 36px;
}

.baggage-info .price-detail .item-table .table-content .tr .tr-title {
  width: 30%;
  font-size: .42667rem;
  color: #999;
  padding-left: .85333rem;
}

.taro {
  position: absolute;
}

.taro-img {
  width: 55px;
  height: 95px;
  position: absolute;
}

.taro-img__content {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
}

.taro-img__scale-to-fill {
  background-size: 100% 100%;
  background-position: 0 0;
}

.taro-img__aspect-fit {
  background-size: contain;
  background-position: 50%
}


.hand-size-width {
  -ms-transform: translate(-33px, 59px);
  transform: translate(-33px, 59px);
  -webkit-transform: translate(-33px, 59px);
  width: 30%;
  font-size: 6.82672px;
  color: #999;
  padding-left: 13.65px;
}

.hand-size-length {
  -ms-transform: translate(29px, 37px);
  transform: translate(29px, 37px);
  -webkit-transform: translate(29px, 37px);
  width: 30%;
  font-size: 6.82672px;
  color: #999;
  padding-left: 13.65px;
}

.hand-size-height {
  -ms-transform: translate(39px, -13px);
  transform: translate(39px, -13px);
  -webkit-transform: translate(39px, -13px);
  width: 30%;
  font-size: 6.82672px;
  color: #999;
  padding-left: 13.65px;
}

.box_list {
  margin: 20px 0 0 0;
}

.box_left {
  height: 77px;
  margin: 15px 0 0 0;
}

.box_h3 {
  font-weight: 600;
  padding: 0px 0px 10px 0;
}

.c {
  span {
    padding: 5px 0 0 0;
  }
}

.t1 {
  background-image: url('../../assets/images/tk/tkQuery/handBaggage1.png') !important;
  width: 49px;
  height: 69px;
}

.t2 {
  background-image: url('../../assets/images/tk/tkQuery/handBaggage-size.png') !important;
  width: 53px;
  height: 72px;
}

.t3 {
  background-image: url('../../assets/images/tk/tkQuery/checkedBaggage.png') !important;
  width: 45px;
  height: 67px;
}

.bz {
  margin: 15px 15px 0px 15px;
  color: #999;
  font-size: 13px;
}

.xl {
  width: 21px;
  height: 21px;
  margin: 0px 8px 0 0;
}

.iconfont-h5 {
  font-family: iconfont-h5 !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.icon-baggage:before {
  content: "";
  font-size: 20px;
  color: #5678a8;
  margin: 0px 7px 0 0;
}

.price-detail-title {
  margin: 10px 0 15px 0;
  line-height: 15px;
}
.lines{
  white-space: nowrap;
    overflow: hidden;
    color:#D3D3D3
}
.title {
  display: flex;
  justify-content: space-between;
}
.back_di{
background: #eff8ff;  
}
.titlenew{
  font-size: 20px;
  font-weight: 800;
}
.font16_w6{
  font-weight: 600 !important;
  font-size: 16px;
  margin-bottom: 6px;
  display: inline-block;
}
</style>
